<template>
    <div>
        <!-- Form and widget -->
        <div class="row py-2">
            <div class="col col-lg-6 col-md-5 col-xl-5">
                <section>
                    <record-form
                        :storePath="recordFormStorePath"
                        @fieldInput="onFieldInput"
                    ></record-form>
                </section>
            </div>

            <widget
                class="col-xl-7 col-lg-6 col-md-6"
                :tabs="widgetTabs"
                :showAlert="true"
                :maxPercent="state.exclusionsPercent"
            >
                <template slot="exclusions">
                    <exclusions-list
                        header="Customer exclusions"
                        :fields="contactFields"
                        :records="state.exclusionsContacts"
                        :loadingState="state.exclusionsLoadingState"
                        :successFieldKeys="contactExclusionFieldKeys">
                    </exclusions-list>
                </template>
            </widget>
        </div>
    </div>
</template>

<script>
    import getters from '../../utils/getters.js';
    import recordForm from './record-form/record-form.vue';
    import widget from './widget/widget.vue';
    import exclusionsList from './widget/exclusions-list.vue';

    export default {
        name: 'contact-create',
        components: {
            'record-form': recordForm,
            'widget': widget,
            'exclusions-list': exclusionsList,
        },
        props: {
            customer: {type: Object, required: true},  // fake to force re-rendering
            storePath: {type: String, required: true},
        },
        computed: {
            widgetTabs() {
                return [
                    {
                        name: 'Exclusions',
                        count: this.state.exclusionsContacts.length,
                        slot: 'exclusions',
                    },
                ];
            },
            recordFormStorePath() {
                return `${this.storePath}/recordForm`;
            },
            state() {
                return getters.getValueByPropertyName(this.$store.state, this.storePath, '/');
            },
            contactFields() {
                return this.$store.getters['worker/recordDetailSession/contactFields'];
            },
            contactExclusionFieldKeys() {
                return this.contactFields.filter(field => field.exclusion).map(field => field.key);
            },
            session() {
                return this.$store.state.worker.recordDetailSession;
            },
        },
        methods: {
            onFieldInput,
        }
    };

    function onFieldInput(key, value) {
        this.$store.dispatch(`${this.storePath}/processExclusions`, [key, value]);
    }
</script>
